import { defineStore } from 'pinia';

export const useDefaultsStore = defineStore('defaults', () => {
    const headerHeight = ref(0);
    const bannerHeight = ref(0);
    const tocHeight = ref(0);
    
    return {
        headerHeight,
        bannerHeight,
        tocHeight,
    };
});